import React from 'react';

import ContactWhatsapp from 'components/Tvendo/Reports/Contact/list.js';

export default function () {
  return <ContactWhatsapp />;
}
